import { render } from "./AlertPage.vue?vue&type=template&id=47cbe456&scoped=true"
import script from "./AlertPage.vue?vue&type=script&lang=js"
export * from "./AlertPage.vue?vue&type=script&lang=js"

import "./AlertPage.vue?vue&type=style&index=0&id=47cbe456&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cbe456"]])

export default __exports__